import { useState, useEffect } from "react";
import Styleclasses from "../Basic-info/style.module.css";
import UploadDc from "./Doc.module.css";
import moment from "moment";
import { FileUploader } from "react-drag-drop-files";
import { Get_Documents, Add_Documents } from "Services/Requests";
import Upload from "Assets/upload.png";
import Load from "Components/Loader/loader";
import { useForm, SubmitHandler } from "react-hook-form";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { config } from "s3config";
import ReactS3Client from "react-aws-s3-typescript";
import { FaDownload } from "react-icons/fa";
import Moment from "react-moment";
import { useStore } from "Store";
import { MdDelete } from "react-icons/md";
type Inputs = {
    download_id: string;
    file_type: string;
    comments: string;
    file_name: string;
};

const Fileupload = () => {
    return (
        <div className={Styleclasses["File-upload"]}>
            <img src={Upload} alt="upload" />
            <p>Upload File</p>
        </div>
    );
};

function PersonalInfo() {
    const { isDisabled } = useStore((state: any) => state);

    const fileTypes = ["JPG", "PNG", "GIF"];
    const [Documents, setDocuments] = useState([]);
    const [UserDetails, setUserDetails] = useState<any>(null);
    const [location, setLocation] = useState("");
    const [loading, setLoading] = useState(false);
    const handleChange = (files: any) => {
        const s3 = new ReactS3Client(config);
        const timestamp = Date.now();
        const newfile = new File(
            [files],
            `${timestamp}.${String(files.type).split("/")[1]}`
        );
        setLoading(true);
        s3.uploadFile(newfile, `${timestamp}`)
            .then((res: any) => {
                console.log(res);
                setLoading(false);
                setLocation(res.location);
                setValue(
                    "download_id",
                    `${timestamp}.${String(files.type).split("/")[1]}`
                );
            })
            .catch((err) => {
                alert(err);
                console.log("err");
            });
    };
    const DocTypes = [
        "W2-wage statement",
        "Personal id proof",
        "1099 INT",
        "1099 DIV",
        "1099-G State Tax Refund",
        "1099 MISC ( Self-employed business income )",
        "1099-B Stock Doc",
        "1099 -R",
        "1099-R (401k plan)",
        "5498 -SA ",
        "1098-T (Tuition fees)",
        "1098-E (interest on your student loan)",
        "1120-K1",
        "1065-k1",
        "1042-S",
        "Residents of MA - 1099HC",
        "Child/Dependent Care expenses (SSN/Tax ID required)",
        "Other",
    ];
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        resetField,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>();
    const formData = watch();
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await Get_Documents("user_upload");

            if (response.data.Status == 1) {
                setLoading(false);
                setDocuments(response?.data?.Documents);
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team1"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
        let detail = localStorage.getItem("UserDetails");
        if (detail) {
            detail = JSON.parse(detail || "");
            setUserDetails(detail);
        }
    }, []);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        console.log(data);
        setLoading(true);
        try {
            const response = await Add_Documents([data]);
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("File Uploaded successfully");
                setLocation("");
                reset();
                GetDetails();
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    console.log(UserDetails);
    return (
        <div className={Styleclasses["Container"]}>
            {loading && <Load />}
            {!isDisabled && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styleclasses["info"]}>
                        <h3>Upload Documents</h3>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Document Name</label>
                            <input
                                type="text"
                                placeholder="Enter Document Name"
                                {...register("file_name", { required: true })}
                            />
                        </div>
                        <div className={Styleclasses["form-control"]}>
                            <label htmlFor="">Document Type</label>
                            <select
                                id=""
                                {...register("file_type", { required: true })}>
                                Please Select
                                {DocTypes.map((item) => (
                                    <option value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <div
                            className={Styleclasses["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <label htmlFor="">Comments</label>
                            <textarea
                                {...register("comments", { required: false })}
                                rows={6}
                                placeholder="Enter Comments"></textarea>
                        </div>
                        <div
                            className={Styleclasses["form-control"]}
                            style={{ gridColumn: "1/-1" }}>
                            <label htmlFor="">Upload File</label>
                            <FileUploader
                                handleChange={handleChange}
                                name="file"
                                children={<Fileupload />}
                            />
                            {location.length > 0 && (
                                <div className={Styleclasses["download-icon"]}>
                                    <div onClick={() => window.open(location)}>
                                        <FaDownload color="#2db2bc" /> Download
                                    </div>
                                    <button
                                        onClick={() => {
                                            setLocation("");
                                            resetField("download_id");
                                        }}>
                                        <MdDelete color="red" />
                                    </button>
                                </div>
                            )}
                        </div>
                        <div
                            className={Styleclasses["action-btns"]}
                            style={{ gridColumn: "1/-1" }}>
                            <button
                                style={{ width: "9rem" }}
                                disabled={location.length == 0}>
                                Upload Doc
                            </button>
                        </div>
                    </div>
                </form>
            )}
            <div className={UploadDc["table"]}>
                <h3>Documents</h3>
                <table>
                    <thead>
                        <th>S No</th>
                        <th>Document Name</th>
                        <th>Document Type</th>
                        <th>Comments</th>
                        <th>Uploaded on</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        {Documents && Documents?.length > 0 ? (
                            Documents?.map((item: any, index: any) => (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{item.file_name}</td>
                                    <td>{item.file_type}</td>
                                    <td>{item.comments}</td>
                                    <td>
                                        <Moment format="DD-MM-YY">
                                            {item.createdAt}
                                        </Moment>
                                    </td>
                                    <td
                                        onClick={() =>
                                            window.open(
                                                String(
                                                    item.download_id
                                                ).includes("https")
                                                    ? item.download_id
                                                    : `https://serenetax.com:8443/taxfiler-0.0.1-SNAPSHOT/api/download/${
                                                          UserDetails?.users_id
                                                      }/${item?.year}/${
                                                          item.download_id
                                                      }?sessionId=${localStorage.getItem(
                                                          "Token"
                                                      )}`,
                                                "_blank"
                                            )
                                        }>
                                        {" "}
                                        <FaDownload color="#2db2bc" />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} style={{ textAlign: "center" }}>
                                    No Documents found{" "}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default PersonalInfo;
